import React, { useCallback } from 'react';
import Card from 'components/inputs/Card';
import { Formik, Form } from 'formik';
import { Row, Col } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import { RESERVE_NOW } from 'actions/chargerOcpp';
import Select from 'components/inputs/Select';
import moment from 'moment';

const ReserveNowSchema = Yup.object().shape({
  connectorId: Yup.number().required('Connector Id is required'),
  expiryDate: Yup.string().required('Expiry date is required!'),
  expiryTime: Yup.string().required('Expiry time is required!'),
  idTag: Yup.string().required('Id tag is required!').trim('Space is not allowed').strict(true),
  // parentIdTag: Yup.string().required('Parent id tag is required!').trim('Space is not allowed').strict(true),
  reservationId: Yup.number().required('Reservation id is required!'),
});

const ReserveNowForm = () => {
  const { chargerId } = useParams();
  const dispatch = useDispatch();
  const chargerDetailData = useSelector((state) => state.charger.chargerDetails);

  const getReserveNow = useCallback((data, resetForm) => {
    dispatch({
      type: RESERVE_NOW,
      payload: { data },
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            toast.success('Reserve now successfully');
            resetForm();
          }
        }
      },
    });
  }, []);

  const initialValues = {
    connectorId: '',
    expiryDate: '',
    expiryTime: '',
    idTag: '',
    parentIdTag: '',
    reservationId: '',
  };

  return (
    <React.Fragment>
      <div className="serverOperation-title-name">RESERVE NOW</div>
      <div className="serverOperation-content-wrapper">
        <Card className="serverOperation-form-main">
          <div className="serverOperation-form__block">
            <Formik
              initialValues={initialValues}
              validationSchema={ReserveNowSchema}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                const retrieveDateMomentObj = moment(values.expiryDate + values.expiryTime, 'YYYY-MM-DDLT');
                const expiryDate = retrieveDateMomentObj.format('YYYY-MM-DD HH:mm:s');
                const formData = {
                  ...values,
                  id: chargerId,
                  expiryDate: expiryDate,
                };
                const reserveNowFormData = _.omit(formData, ['expiryTime']);
                getReserveNow(reserveNowFormData, resetForm);
                setSubmitting(false);
              }}
            >
              {({ values, errors, touched, handleSubmit, handleChange, setFieldValue, isSubmitting }) => (
                <Form onSubmit={handleSubmit}>
                  <div className="serverOperation-form__inner">
                    <Row>
                      <Col md={12}>
                        <Select
                          isRequired
                          label="Connector Name"
                          placeholder="Select Connector Name"
                          options={_.map(_.get(chargerDetailData, 'plugs', []), (item) => {
                            return { label: `${item.name} - ${item.connector_id}`, value: item.connector_id };
                          })}
                          name="connectorId"
                          value={values.connectorId}
                          onChange={(val) => setFieldValue(`connectorId`, val)}
                          error={errors.connectorId && touched.connectorId ? errors.connectorId : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          isRequired
                          label="Expiry Date"
                          type="date"
                          value={values.expiryDate}
                          name="expiryDate"
                          onChange={handleChange}
                          error={errors.expiryDate && touched.expiryDate ? errors.expiryDate : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          isRequired
                          label="Expiry Time"
                          type="time"
                          value={values.expiryTime}
                          name="expiryTime"
                          onChange={handleChange}
                          error={errors.expiryTime && touched.expiryTime ? errors.expiryTime : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          isRequired
                          label="Id Tag"
                          placeholder="Id tag"
                          value={values.idTag}
                          name="idTag"
                          onChange={handleChange}
                          error={errors.idTag && touched.idTag ? errors.idTag : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          // isRequired
                          label="Parent Id Tag"
                          placeholder="Parent id tag"
                          value={values.parentIdTag}
                          name="parentIdTag"
                          onChange={handleChange}
                          // error={errors.parentIdTag && touched.parentIdTag ? errors.parentIdTag : null}
                        />
                      </Col>
                      <Col md={6}>
                        <TextInput
                          isRequired
                          label="Reservation ID"
                          placeholder="Reservation id"
                          type="number"
                          value={values.reservationId}
                          name="reservationId"
                          onChange={handleChange}
                          error={errors.reservationId && touched.reservationId ? errors.reservationId : null}
                        />
                      </Col>
                    </Row>
                  </div>
                  <div className="serverOperation-save--btn--block">
                    <Button type="submit" className="serverOperation-save-btn save--btn" disabled={isSubmitting}>
                      Reserve Now
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
export default ReserveNowForm;
